export default __webpack_public_path__ + "static/media/process_error-icon.66ee720e.svg";